module.exports = __webpack_public_path__ + "static/06-9c3548c13f3f2e8b6829dc6bcc366523.jpg";